/** Quick actions on CCC Página Principal — paths match App routes. */
export type CccHomeActionVariant =
  | 'recuperacao'
  | 'calendario'
  | 'prospeccao'
  | 'retencao'
  | 'resolucao';

export type CccHomeAction = {
  path: string;
  title: string;
  description: string;
  variant: CccHomeActionVariant;
};

export const CCC_HOME_ACTIONS: CccHomeAction[] = [
  {
    path: '/recuperacao',
    title: 'Recuperação',
    description: 'Marcações Comercial em recuperação',
    variant: 'recuperacao',
  },
  {
    path: '/calendario',
    title: 'Calendário',
    description: 'Agenda e marcações',
    variant: 'calendario',
  },
  {
    path: '/prospeccao',
    title: 'Prospeção',
    description: 'Novos contactos e oportunidades',
    variant: 'prospeccao',
  },
  {
    path: '/retencao',
    title: 'Reposição',
    description: 'Acompanhar reposição de clientes',
    variant: 'retencao',
  },
  {
    path: '/resolucao',
    title: 'Resolução',
    description: 'Casos e resolução de pendências',
    variant: 'resolucao',
  },
];
